// Libs
import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';

// Config
import { PATHS } from '~fpu/config/constants';

// Types
import { Workshop } from '../types';

function useCancelWorkshop(workshopId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () =>
      axios.put<Workshop>(PATHS.API.WORKSHOPS.CANCEL(workshopId)),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['workshopDetails', workshopId]
      });
      queryClient.invalidateQueries({ queryKey: ['orgWorkshops'] });
    },
    throwOnError: true
  });
}

export { useCancelWorkshop };
